import { Button, Fab, Snackbar, TextField, Typography } from '@material-ui/core';
import { AddIcon, ColDef } from '@material-ui/data-grid';
import { Alert } from '@material-ui/lab';
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';
import api from '../../config/api'
import { Container } from './styles'


interface Product {
    id: number
    name: string
    description: string
    value: number
    image: string
}

function Products() {
    const [products, setProducts] = useState<Product[]>([])
    const [search, setSearch] = useState('')
    const [filtered, setFiltered] = useState<Product[]>([])
    const [selected, setSelected] = useState([])
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");
    const [loading, setLoading] = useState(false)

    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        fetchProducts()
    }, [])

    async function fetchProducts() {
        const response = await api.get('/products')
        setProducts(response.data.products)
        setFiltered(response.data.products)
        setLoading(false)
    }

    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    function handleSelected(ids: any) {
        setSelected(ids)
    }

    async function handleDelete() {
        try {
            if (selected.length === 1) {
                const id = selected[0]
                await api.delete(`/products/delete/${id}`)
            } else {

                await api.delete(`/products/deletebatch`,
                    {
                        data: {
                            products_id: selected
                        }
                    }
                )
            }
            setOpenSuccess(true)
            fetchProducts()
        } catch (err) {
            setOpenFailed(true)
        }
    }

    async function handleUpdate() {
        const id = selected[0]
        history.push(`/products/update/${id}`)
    }

    function handleSearch(e: React.ChangeEvent<HTMLInputElement>) {
        setSearch(e.target.value)

        if (e.target.value.trim() === '') {
            setFiltered(products)
        } else {
            const filteredProducts = products.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
            setFiltered(filteredProducts)
        }
    }

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'name', headerName: 'Nome', width: 300 },
        { field: 'description', headerName: 'Descrição', width: 500, },
        {
            field: 'value',
            headerName: 'Valor',
            width: 100
        }
    ];

    return (
        <Container>
            {
                loading ?

                    <Loading />
                    :
                    <>
                        <Link to="/products/create" >
                            <Fab color="secondary" aria-label="add" className="floating-button">
                                <AddIcon />
                            </Fab>
                        </Link>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                                Lista de produtos
                            </Typography>
                            <div style={{ marginLeft: 50 }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ margin: '10px 10px' }}
                                    disabled={selected.length !== 1 ? true : false}
                                    onClick={handleUpdate}
                                >
                                    Atualizar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ margin: '10px 10px' }}
                                    disabled={selected.length > 0 ? false : true}
                                    onClick={handleDelete}
                                >
                                    Deletar
                                </Button>
                            </div>
                        </div>
                        <TextField
                            className="search-bar"
                            value={search}
                            label="Busque um produto"
                            variant="outlined"
                            onChange={handleSearch}
                        />
                        <DataTable columns={columns} rows={filtered} check={true} handleSelected={handleSelected} />
                        <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                            <Alert onClose={handleCloseSuccess} severity="success">
                                Produto deletado com sucesso!
                            </Alert>
                        </Snackbar>

                        <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                            <Alert onClose={handleCloseFailed} severity="error">
                                {errorMessage}
                            </Alert>
                        </Snackbar>
                    </>
            }
        </Container>
    );
}

export default Products